import loadable from "@loadable/component";

export const DeviceList = loadable(() => import("./list"));
export const DeviceShow = loadable(() => import("./show"));
